/**
 * Created by staffanrantzow on 10/11/16.
 */

import React, { PropTypes } from 'react';
import Modal from 'react-modal';
import { proxyCounterpart } from '../../../../scripts/proxyCounterpart';
import Translate from 'react-translate-component';
import SupplierLedgerForm from './form/supplier-ledger-form-container';
import SupplierLedgerList from './list/supplier-ledger-list-container';

class SupplierLedgerModal extends React.Component {

  static propTypes = {
    close: PropTypes.func.isRequired
  };

  renderDeductionInfo () {
    return (
      <p>
        <span
          dangerouslySetInnerHTML={{__html: proxyCounterpart('DEDUCTION_FILE_INFO')}}>
        </span>
        <br />
      </p>);
  }

  render () {
    return (
      <Modal
        className='modal modal-extra-wide'
        isOpen
        contentLabel=''
        onRequestClose={this.reject}>
        <div className='modal-content supplier-ledger-modal'>
          <button className='close' onClick={this.props.close}></button>

          <div className="heading-wrapper">
            <h2><Translate content='ADD_DEDUCTION'/></h2>
          </div>
          {this.renderDeductionInfo()}
          <SupplierLedgerForm close={this.props.close}/>
          <SupplierLedgerList/>
        </div>
      </Modal>
    );
  }

}

export default SupplierLedgerModal;



/** WEBPACK FOOTER **
 ** ./src/views/invoice-tool/distribution/supplier-ledger/supplier-ledger-modal.js
 **/